import { action, thunkOn } from "easy-peasy";
import { onLogoutResolver } from "./on-logout-resolver";

const modelFlopptions = {
  INITIAL_DATA_ENDPOINT: "flopptions",
  INCLUDE_APP_MODE_IN_INITIALDATA_REQUEST: true,
  INCLUDE_ITIN_MODE_IN_INITIALDATA_REQUEST: true,
  NAME: "flopptions",
  initialData: {},
  rowsByTripLegId: {},
  initialDataReceived: false,
  initialDataLoading: false,
  /////////////
  // ACTIONS //
  /////////////
  resetData: action((state) => {
    state.initialData = {};
    state.rowsByTripLegId = {};
    state.initialDataReceived = false;
    state.initialDataLoading = false;
  }),
  onLogout: thunkOn(onLogoutResolver, (actions) => {
    actions.resetData();
  }),
  // receivedFor: computed(
  //   state =>
  //     new Set(
  //       state.initialData.map(({ TripId, leg_i }) => `${TripId}-${leg_i}`)
  //     )
  // ),
  onReportAction: thunkOn(
    (actions, storeActions) =>
      storeActions.actionReports.handleSubmitActionReport,
    async (actions, target, { getState }) => {
      // actions.receiveInitialData(
      //   filterAfterActionReported(getState().initialData, target)
      // );
      await actions.handleFetchInitialData();
    }
  ),
  receiveInitialData: action((state, newFlopptions) => {
    state.initialData = {};
    state.rowsByTripLegId = {};
    newFlopptions.forEach((flop) => {
      flop.id = flop.flopption_id;
      state.initialData[flop.flopption_id] = flop;
      state.rowsByTripLegId[flop["TripId-leg_i"]] = [
        ...(state.rowsByTripLegId[flop["TripId-leg_i"]] || []),
        flop,
      ];
    });
  }),
  // receiveInitialData: action((state, newFlopptions) => {
  //   state.initialData = _.uniqBy(
  //     [...state.initialData, ...newFlopptions].map(row => ({
  //       ...row,
  //       id: hashFlopption(row)
  //     })),
  //     "id"
  //   );
  // }),
  // rowsByTripLegId: computed(
  //   [state => state.initialData],
  //   initialData => ({ TripId, leg_i }) => {
  //     if (TripId === null || leg_i === null) return [];
  //     const key = `${TripId}-${leg_i}`;
  //     return initialData.filter(row => row["TripId-leg_i"] === key);
  //   }
  // ),
  // maybeFetchOne: thunk(async (actions, { TripId, leg_i }, { getState }) => {
  //   const receivedFor = getState().receivedFor;
  //   console.log({
  //     receivedFor,
  //     has: receivedFor.has(`${TripId}.${leg_i}`),
  //     id: `${TripId}.${leg_i}`
  //   });
  //   if (receivedFor.has(`${TripId}.${leg_i}`)) return null;
  //   const resp = await makeAuthorizedGetRequestToBackend({
  //     url: makeUrl(`flopptions/${TripId}/${leg_i}`)
  //   });
  //   actions.receiveInitialData(resp.data);
  // }),
  // onVfOpenModal: thunkOn(
  //   (actions, storeActions) => storeActions.misc.vf_openModal,
  //   async (actions, target) => {
  //     await actions.maybeFetchOne(target.payload.snapshot);
  //   }
  // ),
  // onSignedIn: thunkOn(
  //   (actions, storeActions) => storeActions.me.receiveInitialData,
  //   async actions => {
  //     await actions.maybeHandleFetchInitialData();
  //   }
  // ),
  maybeHandleFetchInitialData: undefined,
  handleFetchInitialData: undefined,
  markInitialDataReceived: undefined,
};

export default modelFlopptions;
